import { render, staticRenderFns } from "./AcessoriesList.vue?vue&type=template&id=a21caea0"
import script from "./AcessoriesList.vue?vue&type=script&lang=js"
export * from "./AcessoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports